// After a deploy, an open tab can request page files from the previous build. boot.js reloads once on Vite's
// preloadError; when that guard has already fired, the error reaches the error boundary instead.
export function isStaleChunk(error: unknown): boolean {
  const message = String((error as Error)?.message ?? error);
  return /dynamically imported module|Importing a module script failed|error loading dynamically imported module|Loading chunk [\w-]+ failed/i.test(message);
}
